<template>
  <div id="b-toaster-top-right" class="b-toaster b-toaster-top-right">
    <div class="b-toaster-slot vue-portal-target">
      <transition-group mode="out-in" type="animation" name="slide">
        <k-toast
          v-for="notification in notifications"
          :notification="notification"
          :key="notification.id"
          @hide="remove(notification.id)"
      /></transition-group>
    </div>
  </div>
</template>
<script>
import KToast from './k-toast.vue';

export default {
  name: 'Notifications',
  data() {
    return {
      emptyHtml: '&nbsp;',
      prior: [],
    };
  },
  components: {
    'k-toast': KToast,
  },
  watch: {
    notifications(newVal) {
      const removedValues = this.prior.filter((x) => !newVal.includes(x));
      this.prior = newVal;

      removedValues.forEach((element) => {
        this.$nextTick(() => this.$bvToast.hide(element.id));
      });
    },
  },
  computed: {
    notifications() {
      return this.$store.state.notifications.filter( x => x.toast );
    },
  },
  methods: {
    remove(id) {
      this.$store.commit('removeNotification', id);
    },
  },
  // mounted() {
  //   this.$store.commit('addNotification', {
  //     type: 'info',
  //     htmlMessage: 'This is <b>a test message</b>',
  //   });
  //   this.$store.commit('addNotification', {
  //     type: 'error',
  //     message: 'ERROR!!!!!',
  //   });
  //   this.$store.commit('addNotification', {
  //     type: 'warning',
  //     htmlMessage: '<b>WARNING!!!!!</b>',
  //   });
  //   this.$store.commit('addNotification', {
  //     type: 'warning',
  //     message: 'WARNING!!!!!',
  //   });
  // },
};
</script>
<style scoped>
/* toasts */
.vue-portal-target >>> .b-toaster.b-toaster-top-right .b-toaster-slot,
.vue-portal-target >>> .b-toast,
.vue-portal-target >>> .toast {
  max-width: 425px;
}
.vue-portal-target >>> .toast-body {
  background-color: white;
  color: black;
  border: lightgray solid 1px;
}
.vue-portal-target >>> .b-toast.b-toast-solid .toast {
  background-color: white;
  color: black;
  border: lightgray solid 1px;
}
.vue-portal-target >>> .b-toast .toast .toast-header {
  background-color: white;
}

.vue-portal-target >>> .b-toast-error .toast .toast-header {
  border-bottom-color: #dd0000;
  color: #dd0000;
}

.vue-portal-target >>> .b-toast-error .toast {
  border-left: red solid 0.5rem;
}

.vue-portal-target >>> .b-toast-warning .toast .toast-header {
  border-bottom-color: #d19414;
  color: #d19414;
}

.vue-portal-target >>> .b-toast-warning .toast {
  border-left: #f1b434 solid 0.5rem;
}

.vue-portal-target >>> .b-toast-info .toast {
  border-left: #5acd28 solid 0.5rem;
}

.vue-portal-target >>> .toast,
.vue-portal-target >>> .toast-header {
  background-color: white;
  color: black;
  border: lightgray solid 1px;
}

/* Toast animation */
.slide-enter {
  opacity: 0;
}

.slide-move {
  transition: transform 1s;
}

.slide-enter-active {
  animation: slide-in 0.5s ease-out forwards;
  transition: opacity 0.5s;
}

.slide-leave-active {
  position: absolute;
  width: 100%;
  animation: slide-out 0.5s ease-out forwards;
  transition: opacity 0.5s;
  opacity: 0;
}

@keyframes slide-in {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0px);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(350px);
  }
}
</style>
